import React, { useState } from "react";

export default function ConfirmationModal({ id, callback, setClose }) {
  const [isLoading, setIsLoading] = useState(false);

  async function removeModal() {
    try {
      setIsLoading(true);
      await callback(id);
      setClose();
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div
      className="z-50 fixed inset-0 flex justify-center items-center bg-opacity-50"
      onClick={setClose} // Close modal on overlay click
    >
      <div
        className="bg-white shadow-cs p-6 rounded-lg w-full max-w-lg h-[200px]"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <h2 className="mt-[28px] mb-[28px] font-semibold text-[18px] text-[black] text-center text-xl">
          Are you sure want to Delete this ?{" "}
        </h2>

        <div className="flex justify-around">
          <button
            onClick={removeModal}
            disabled={isLoading ?? false}
            className={`px-4 py-2 bg-[#27004a] text-[14px] text-white rounded-md ${
              isLoading ? "opacity-50" : ""
            }`}
          >
            {isLoading ? "Confirming..." : " Yes , Confirm"}
          </button>
          <button
            onClick={setClose}
            className="bg-[#27004a] px-4 py-2 rounded-md text-[14px] text-white"
          >
            No , Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
